import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SalesReportView from '../salesReport/SalesReportView';
import { rotaDaVenda, vendaTemDetalhe } from '../salesReport/navegacaoDaVenda';

const useStyles = makeStyles((theme) => ({
  page: { maxWidth: 1440, margin: '0 auto', padding: theme.spacing(3) },
  header: { marginBottom: theme.spacing(3) },
  title: { fontSize: '1.5rem', fontWeight: 600, color: '#0f172a', lineHeight: 1.2 },
  subtitle: { color: '#64748b', fontSize: '0.9rem', marginTop: theme.spacing(0.5) },
}));

/** Relatório de Vendas: todas as vendas da estação, com os totais do período. */
const PaymentLinksReport = ({ auth, router }) => {
  const classes = useStyles();
  const station = auth?.user?.establishments?.[0]?.stations?.[0] || {};

  return (
    <Box className={classes.page}>
      <div className={classes.header}>
        <Typography className={classes.title}>Relatório de Vendas</Typography>
        <Typography className={classes.subtitle}>
          {station.name || 'Minha entidade'} · todas as vendas (links, pedidos e assinaturas)
          processadas na plataforma
        </Typography>
      </div>
      <SalesReportView
        stationId={station.id || null}
        showKpis
        isRowClickable={vendaTemDetalhe}
        onRowClick={(row) => router && router.push(rotaDaVenda(row))}
      />
    </Box>
  );
};

PaymentLinksReport.propTypes = {
  auth: PropTypes.shape({ user: PropTypes.any }),
  router: PropTypes.shape({ push: PropTypes.func }),
};

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps)(PaymentLinksReport);
